var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sales"}},[_c('Datatable',{staticClass:"datatable",attrs:{"entity":"sale_status"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }